import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { api, errorMessage } from "../lib/api";

export const CalendarConnection = ({ session }) => {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get("/calendar/status").then(({ data }) => setStatus(data))
    .catch((e) => setError(errorMessage(e))); }, []);
  const disconnect = async () => {
    try { await api.post("/calendar/disconnect", {}, { headers: { "X-CSRF-Token": session.csrf_token } });
      setStatus({ ...status, connected: false }); }
    catch (e) { setError(errorMessage(e)); }
  };
  return <div className="calendar-connection" data-testid="calendar-connection">
    <div className="section-label"><CalendarDays size={17} aria-hidden="true" /> GOOGLE CALENDAR</div>
    {status?.connected ? <><p data-testid="calendar-connected">Collegato · i tuoi impegni personali escludono gli orari occupati.</p>
      <button type="button" className="text-action" onClick={disconnect} data-testid="calendar-disconnect">Scollega Calendar</button></>
      : <><p data-testid="calendar-not-connected">Non collegato · gli incontri restano nell'Agenda del CRM. Gli inviti Google attendono il collegamento.</p>
        {status?.available && <a className="hud-button hud-secondary" href={`${process.env.REACT_APP_BACKEND_URL}/api/v1/calendar/connect`}
          data-testid="calendar-connect">Collega il mio Google Calendar</a>}</>}
    {error && <p className="form-error" role="alert" data-testid="calendar-connection-error">{error}</p>}
  </div>;
};